import { CaretRight } from "@/components/shared/icons";
import { Card, CardContent, Image, View } from "@/components/ui";
import { Typography } from "@/components/shared/typography";
import MainCreditAccount from "@/assets/images/3d-icons/main-credit-account.png";
import { useRoute } from "@/components/shared/router";
import { useProfileState } from "@/store/profile";
import { InfoHelper } from "./info-helper";

type GeneralCreditOverviewCardProps = {
  balance: string;
};

export const GeneralCreditOverviewCard = ({
  balance,
}: GeneralCreditOverviewCardProps) => {
  const { push } = useRoute();
  const { setCreditAccountType } = useProfileState();

  const emptyBalance = parseInt(balance) === 0;
  const emptyBalanceMsg = emptyBalance
    ? "Earn credits by referring your friends"
    : "";

  const handleClick = () => {
    push({
      pageKey: "creditAccountGeneral",
    });
    setCreditAccountType("general");
  };

  return (
    <Card shadow="sm" onClick={handleClick}>
      <CardContent>
        <View className="flex flex-row items-center gap-2">
          <Image
            src={MainCreditAccount}
            className="size-8 md:size-14"
            width={32}
            height={32}
          />
          <View className="flex flex-1 flex-col gap-1">
            <View className="align-center flex flex-row items-center gap-1">
              <Typography variant="label-md">Main Credit</Typography>
              <InfoHelper />
            </View>

            <Typography variant="caption-md" color="foreground-intermediate">
              {emptyBalanceMsg}
            </Typography>
          </View>
          <View className="flex flex-row items-center justify-between">
            <Typography variant="label-lg" color={"brand-primary"}>
              ${balance}
            </Typography>

            <View className="flex flex-row items-center gap-2 px-3">
              <CaretRight className="size-4" size={16} />
            </View>
          </View>
        </View>
      </CardContent>
    </Card>
  );
};
